import React, { useEffect, useState } from 'react';
import { CircularProgress, Grid } from '@mui/material';
//import SVG from 'react-inlinesvg';
//import { BRAND_COLOR } from '../../../../common/constants/colors';
import { NWClient } from '../../../../client/NWClient';
//import { getResourceLink } from '../../../../common/utils';
import SubscriptionItem from './SubscriptionItem/SubscriptionItem';
import { Helpers } from '../../../../common/helpers/helpers';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../common/constants/routes';
import { useTranslation } from 'react-i18next';

export const SubscriptionDetailsTab = (/*{ currentTab }: TabProps*/) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [subscription, setSubscription] = useState(null);
  const [planName, setPlanName] = useState('');
  const [plan, setPlan] = useState(null);
  const [errorTextArray, setErrorTextArray] = useState([]);
  const { t } = useTranslation();
  const setChargeAmount = () => {
    if (subscription && plan) {
      if (!subscription.discount) {
        return plan.amount_decimal.length > 0
          ? (parseFloat(plan.amount_decimal) / 100).toFixed(2)
          : (plan.amount_decimal / 100).toFixed(2);
      } else {
        if (subscription.discount.coupon.amount_off) {
          return plan.amount_decimal.length > 0
            ? (
                parseFloat(plan.amount_decimal) / 100 -
                subscription.discount.coupon.amount_off / 100
              ).toFixed(2)
            : (plan.amount_decimal / 100 - subscription.discount.coupon.amount_off / 100).toFixed(
                2
              );
        }
        if (subscription.discount.coupon.percent_off) {
          const amount =
            plan.amount_decimal.length > 0
              ? parseFloat(plan.amount_decimal) / 100
              : plan.amount_decimal / 100;
          return (amount - amount * (subscription.discount.coupon.percent_off / 100)).toFixed(2);
        }
      }
    } else {
      return '0';
    }
  };
  const chargeAmount = setChargeAmount();
  const chargeCurrency = subscription && plan ? plan.currency : '';
  const DefaultMessage = () => {
    return (
      <p className='text-center'>
        {t('messages.noActiveSubscription')}&nbsp;
        <Link className='link-brand-color' to={ROUTES.PRICING}>
          {t('links.pricingOptions')}
        </Link>
        .
      </p>
    );
  };

  useEffect(() => {
    setLoading(true);
    NWClient.getCurrentCompany()
      .then((res) => {
        if (Array.isArray(res) && res.length > 0 && res[0].stripe_subscription) {
          setSubscription(res[0].stripe_subscription);
          setPlanName(res[0].stripe_product_name.replace('Business ', ''));
          NWClient.get('plan', String(res[0].stripe_subscription.plan))
            .then((res) => {
              setPlan(res);
            })
            .catch((error) => {
              Helpers.handleRequestError(error.response, setErrorTextArray, setLoading);
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        Helpers.handleRequestError(error.response, setErrorTextArray, setLoading);
      });
  }, []);

  return (
    <Grid>
      {loading ? (
        <Grid container justifyContent='center'>
          <CircularProgress />
        </Grid>
      ) : (
        <Grid>
          <div className='setting-panel-body ps-0 pe-0 pt-0'>
            {subscription && subscription.status !== 'canceled' ? (
              <SubscriptionItem
                planName={planName}
                currentPeriodEnd={Helpers.formatDBDateToUI(subscription.current_period_end)}
                currentPeriodStart={Helpers.formatDBDateToUI(subscription.current_period_start)}
                status={subscription.status}
                startDate={Helpers.formatDBDateToUI(subscription.start_date)}
                errorTextArray={errorTextArray}
                discount={subscription.discount}
                chargeDate={Helpers.formatDBDateToUI(subscription.current_period_end)}
                chargeAmount={String(chargeAmount)}
                chargeCurrency={chargeCurrency}
              />
            ) : (
              <DefaultMessage />
            )}
          </div>
        </Grid>
      )}
    </Grid>
  );
};
